import request from '@/config/axios'

/** 主攻品类选项（与后端 MasterConstants 四品类对齐） */
export const MASTER_CATEGORY_OPTIONS: { label: string; value: string }[] = [
  { label: '命理八字', value: 'bazi' },
  { label: '风水堪舆', value: 'feng' },
  { label: '奇门遁甲', value: 'qimen' },
  { label: '六壬神课', value: 'liuren' }
]

/** 品类标签映射 */
export const MASTER_CATEGORY_LABELS: Record<string, string> = {
  bazi: '命理八字',
  feng: '风水堪舆',
  qimen: '奇门遁甲',
  liuren: '六壬神课'
}

/** 审核状态选项与映射（0=待审核 1=通过 2=驳回） */
export const MASTER_AUDIT_STATUS_OPTIONS: { label: string; value: number }[] = [
  { label: '待审核', value: 0 },
  { label: '已通过', value: 1 },
  { label: '已驳回', value: 2 }
]

export const MASTER_AUDIT_STATUS_LABELS: Record<number, string> = {
  0: '待审核',
  1: '已通过',
  2: '已驳回'
}

export const MASTER_AUDIT_STATUS_TAG_TYPES: Record<number, string> = {
  0: 'warning',
  1: 'success',
  2: 'danger'
}

/** 入驻申请 VO */
export interface MasterApplyVo {
  id: number
  memberId: number
  memberNickname?: string
  mobile?: string
  category: string
  realName: string
  idCardNo?: string
  phone?: string
  years: number
  title?: string
  intro?: string
  qualificationUrls?: string
  auditStatus: number
  auditRemark?: string
  auditTime?: Date
  createTime?: Date
}

/** 入驻申请分页查询参数 */
export interface MasterApplyPageParams {
  pageNo?: number
  pageSize?: number
  auditStatus?: number
  category?: string
  nickname?: string
  mobile?: string
}

/** 审核请求参数 */
export interface MasterApplyAuditParams {
  id: number
  approved: boolean
  remark?: string
}

/** 师傅档案 VO（师傅必须绑定会员账号：mobile 为绑定会员手机号，头像/昵称/手机号展示取会员信息） */
export interface MasterVo {
  id?: number
  /** 绑定会员手机号（新增/修改必填，后端按手机号定位会员） */
  mobile: string
  /** 会员昵称（展示，后端按 memberId 填充） */
  memberNickname?: string
  /** 会员头像（展示，师傅头像取会员头像） */
  memberAvatar?: string
  category: string
  name: string
  sealChar?: string
  title?: string
  tags?: string
  years?: number
  intro?: string
  qualificationUrls?: string
  consultCount?: number
  goodRate?: number
  status?: number
  createTime?: Date
}

/** 师傅档案分页查询参数 */
export interface MasterPageParams {
  pageNo?: number
  pageSize?: number
  name?: string
  category?: string
  status?: number
}

export const MasterApplyApi = {
  // 查询入驻申请分页（昵称模糊/手机号精确）
  getApplyPage: (params: MasterApplyPageParams) => {
    return request.get({ url: '/xuanxue/master-apply/page', params })
  },
  // 审核入驻申请（通过时同事务自动建档）
  auditApply: (data: MasterApplyAuditParams) => {
    return request.put({ url: '/xuanxue/master-apply/audit', data })
  }
}

export const MasterApi = {
  // 查询师傅档案分页
  getMasterPage: (params: MasterPageParams) => {
    return request.get({ url: '/xuanxue/master/page', params })
  },
  // 查询师傅档案详情（编辑回显）
  getMaster: (id: number) => {
    return request.get({ url: '/xuanxue/master/get?id=' + id })
  },
  // 新增师傅档案（平台端直录）
  createMaster: (data: MasterVo) => {
    return request.post({ url: '/xuanxue/master/create', data })
  },
  // 修改师傅档案
  updateMaster: (data: MasterVo) => {
    return request.put({ url: '/xuanxue/master/update', data })
  },
  // 修改师傅档案状态（上架/下架，下架即身份停用）
  updateMasterStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/master/update-status', params: { id, status } })
  }
}
